import React from 'react'

const Indent = () => {
  return (
    <React.Fragment>
      &nbsp;&nbsp;&nbsp;
    </React.Fragment>
  )
}

export default Indent


// WEBPACK FOOTER //
// ./src/components/Common/Indent.js